(function () {
  'use strict';

  var CAT = '/pages/screen-printing-pricing-calculator';
  var SSCDN = 'https://cdn.ssactivewear.com/Images/';
  var MAX = 6;
  var loadQueue = null, loadFailed = false, seq = 0;

  var rvaSearch = window.rvaSearch || (function () {
    var PHRASES = [
      [/&/g, ' and '],
      [/\bt[\s-]*shirts?\b/g, 'tshirt'],
      [/(?:\b1\/4|\bquarter)[\s-]*zips?\b/g, 'quarterzip'],
      [/(?:\b1\/2|\bhalf)[\s-]*zips?\b/g, 'halfzip'],
      [/\bfull[\s-]*zips?\b/g, 'fullzip'],
      [/\blong[\s-]*sleeves?\b/g, 'longsleeve'],
      [/\bshort[\s-]*sleeves?\b/g, 'shortsleeve'],
      [/\bcrew[\s-]*necks?\b/g, 'crewneck'],
      [/\bv[\s-]*necks?\b/g, 'vneck'],
      [/\bsweat[\s-]*shirts?\b/g, 'sweatshirt'],
      [/\btank[\s-]*tops?\b/g, 'tank']
    ];

    var WORDS = { tshirt: 1, quarterzip: 1, halfzip: 1, fullzip: 1, longsleeve: 1, shortsleeve: 1, crewneck: 1, vneck: 1, sweatshirt: 1, tank: 1 };
    var W = ['women', 'ladies', '@w'], Y = ['youth', '@y'], A = ['@adult'];
    var SYN = {
      hoodie: ['hood'], hoody: ['hood'], hooded: ['hood'], hood: ['hood'],
      sweatshirt: ['sweatshirt', '@fleece'], sweater: ['sweatshirt', '@fleece'], fleece: ['fleece', '@fleece'],
      crewneck: ['crewneck', 'crew'],
      tshirt: ['tshirt', 'tee'], tee: ['tee', 'tshirt'],
      longsleeve: ['longsleeve', '@ls'],
      women: W, womens: W, woman: W, ladies: W, lady: W, female: W,
      youth: Y, kid: Y, kids: Y, child: Y, children: Y, childrens: Y, boy: Y, boys: Y,
      men: A, mens: A, man: A, male: A, adult: A, adults: A, unisex: ['unisex', '@adult']
    };

    var ONLY = { men: 1, mens: 1, man: 1, male: 1 };

    var STOP = { a: 1, an: 1, the: 1, and: 1, for: 1, with: 1, of: 1, in: 1, on: 1, up: 1, my: 1, our: 1, custom: 1, customized: 1, personalized: 1,
      print: 1, printed: 1, printing: 1, screen: 1, screenprinted: 1, blank: 1, blanks: 1, cheap: 1, bulk: 1 };
    function norm(v) {
      var s = String(v == null ? '' : v).toLowerCase().replace(/[‘’'`´]/g, '');
      PHRASES.forEach(function (p) { s = s.replace(p[0], p[1]); });
      return s.replace(/[^a-z0-9]+/g, ' ').trim();
    }
    function alts(t) {
      var out = [];
      function add(x) { if (x && out.indexOf(x) < 0) out.push(x); }
      function base(x) {
        if (!ONLY[x]) add(WORDS[x] ? '^' + x : x);
        (SYN[x] || []).forEach(function (y) { add(y.charAt(0) === '@' ? y : '^' + y); });
      }
      base(t);
      if (t.length > 3 && /ies$/.test(t)) { base(t.slice(0, -3) + 'y'); base(t.slice(0, -1)); }
      else if (t.length > 3 && /s$/.test(t) && !/ss$/.test(t)) base(t.slice(0, -1));
      return out;
    }
    function parse(raw) {
      var q = norm(raw), words = q ? q.split(' ').filter(function (w) { return !STOP[w]; }) : [];
      return { q: q, words: words, alts: words.map(alts) };
    }
    function hay(st) {
      var h = ' ' + norm(st.b + ' ' + st.n + ' ' + st.s) + ' ';
      if (st.__rvaHayKey === st.b + '|' + st.n + '|' + st.s) return st.__rvaHay;
      try {
        Object.defineProperty(st, '__rvaHay', { value: h, configurable: true, writable: true });
        Object.defineProperty(st, '__rvaHayKey', { value: st.b + '|' + st.n + '|' + st.s, configurable: true, writable: true });
      } catch (e) {}
      return h;
    }
    function hit(st, h, a) {
      var c = a.charAt(0);
      if (c === '^') return h.indexOf(' ' + a.slice(1)) >= 0;
      if (c !== '@') return h.indexOf(a) >= 0;
      if (a === '@w') return !!st.w;
      if (a === '@y') return !!st.y;
      if (a === '@adult') return !st.w && !st.y;
      if (a === '@fleece') return st.t === 'fleece';
      if (a === '@ls') return st.t === 'ls';
      return false;
    }
    function test(st, p) {
      if (!p || !p.words.length) return true;
      var h = hay(st);
      return p.alts.every(function (list) { return list.some(function (a) { return hit(st, h, a); }); });
    }
    function marks(p) {
      var out = [];
      (p && p.alts || []).forEach(function (list) {
        list.forEach(function (a) {
          if (a.charAt(0) === '@') return;
          if (a.charAt(0) === '^') a = a.slice(1);
          (a === 'tshirt' ? ['t-shirt', 'tshirt'] : a === 'longsleeve' ? ['long sleeve'] : a === 'quarterzip' ? ['quarter-zip', '1/4-zip'] :
            a === 'crewneck' ? ['crewneck', 'crew neck'] : a === 'vneck' ? ['v-neck'] : a === 'fullzip' ? ['full-zip'] : [a]).forEach(function (m) {
            if (out.indexOf(m) < 0) out.push(m);
          });
        });
      });
      return out;
    }
    return { norm: norm, parse: parse, test: test, marks: marks };
  })();
  window.rvaSearch = rvaSearch;

  var RULES = [
    ['.rvaSug', 'position:absolute;left:0;top:calc(100% + 8px);z-index:90;width:400px;max-width:calc(100vw - 16px);background:#fff;color:#14141a;' +
      'border:1px solid #e6e1d8;border-radius:16px;box-shadow:0 2px 6px rgba(20,20,26,.06),0 18px 44px rgba(20,20,26,.14);padding:6px;text-align:left;' +
      'font-family:"Outfit",-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif;letter-spacing:0;line-height:1.3;box-sizing:border-box'],
    ['.rvaSug[hidden]', 'display:none'],
    ['.rvaSug ul', 'list-style:none;margin:0;padding:0'],
    ['.rvaSug li', 'margin:0;padding:0;list-style:none'],
    ['.rvaSug .rvaSug__it', 'display:flex;align-items:center;gap:12px;width:100%;min-height:56px;margin:0;padding:7px 10px 7px 7px;border:0;border-radius:11px;' +
      'background:none;cursor:pointer;text-align:left;text-decoration:none;color:#14141a;font-family:inherit;box-sizing:border-box'],
    ['.rvaSug .rvaSug__it:hover,.rvaSug .rvaSug__it[aria-selected="true"]', 'background:#f2efe9;text-decoration:none;color:#14141a'],
    ['.rvaSug .rvaSug__pic', 'width:42px;height:42px;flex:none;display:grid;place-items:center;padding:2px;border:1px solid #f0ece5;border-radius:9px;background:#fff;overflow:hidden'],
    ['.rvaSug .rvaSug__pic img,.rvaSug .rvaSug__pic svg', 'width:100%;height:100%;max-height:100%;object-fit:contain;display:block'],
    ['.rvaSug .rvaSug__pic i', 'display:block;width:26px;height:26px;border-radius:50%;border:1px solid rgba(20,20,26,.16)'],
    ['.rvaSug .rvaSug__txt', 'flex:1;min-width:0;display:flex;flex-direction:column;gap:2px;line-height:1.25'],
    ['.rvaSug .rvaSug__txt b', 'display:block;font-size:14px;font-weight:700;letter-spacing:-.01em;color:#14141a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis'],
    ['.rvaSug .rvaSug__txt b mark', 'background:none;color:#0b7ea6;font-weight:800'],
    ['.rvaSug .rvaSug__txt em', 'display:block;font-style:normal;font-size:12px;font-weight:500;color:#5a5a64;white-space:nowrap;overflow:hidden;text-overflow:ellipsis'],
    ['.rvaSug .rvaSug__pr', 'flex:none;display:flex;flex-direction:column;align-items:flex-end;line-height:1.1;font-variant-numeric:tabular-nums'],
    ['.rvaSug .rvaSug__pr b', 'font-size:14px;font-weight:800;letter-spacing:-.02em;color:#14141a'],
    ['.rvaSug .rvaSug__pr small', 'font-size:9.5px;font-weight:600;color:#8b8b95;margin-top:2px'],
    ['.rvaSug .rvaSug__all', 'display:flex;align-items:center;justify-content:center;gap:6px;width:100%;margin:4px 0 0;padding:11px 10px;border:0;border-top:1px solid #f0ece5;' +
      'border-radius:0 0 10px 10px;background:none;cursor:pointer;font-family:inherit;font-size:12.5px;font-weight:700;line-height:1;color:#0b7ea6;text-align:center;box-sizing:border-box'],
    ['.rvaSug .rvaSug__all:hover', 'color:#14141a;background:#f2efe9'],
    ['.rvaSug .rvaSug__none', 'padding:14px 12px;font-size:13px;color:#5a5a64;text-align:center']
  ];
  var CSS = RULES.map(function (r) { return r[0] + '{' + r[1] + '}'; }).join('') +
    RULES.map(function (r) { return r[0].split(',').map(function (sel) { return '#rvaCat ' + sel.trim(); }).join(',') + '{' + r[1] + '}'; }).join('') +
    '@media (max-width:749px){.rvaSug .rvaSug__pr small{display:none}}';

  function injectCSS() {
    if (document.getElementById('rvaSugCss')) return;
    var st = document.createElement('style');
    st.id = 'rvaSugCss';
    st.textContent = CSS;
    document.head.appendChild(st);
  }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function styleHref(st) { return '/pages/' + slug(st.b + '-' + st.s); }
  function haveStyles() { return Array.isArray(window.STYLES) && window.STYLES.length > 0; }

  function ensureData(cb) {
    if (haveStyles()) { cb(); return; }
    var urls = window.RVA_CAT_DATA;
    if (loadFailed || !Array.isArray(urls) || !urls.length) return;
    if (loadQueue) { loadQueue.push(cb); return; }
    loadQueue = [cb];
    (function next(i) {
      if (i >= urls.length) {
        var q = loadQueue; loadQueue = null;
        if (haveStyles()) q.forEach(function (f) { try { f(); } catch (e) {} });
        return;
      }
      var s = document.createElement('script');
      s.src = urls[i];
      s.async = false;
      s.onload = function () { next(i + 1); };
      s.onerror = function () { loadFailed = true; loadQueue = null; };
      document.head.appendChild(s);
    })(0);
  }

  function leadColor(st) {
    if (window.S && window.S.swatch && st.id && window.S.swatch[st.id]) return window.S.swatch[st.id];
    if (st.lead) return st.lead;
    var c = st.c || [];
    for (var i = 0; i < c.length; i++) if (c[i][3]) return c[i];
    return c[0] || null;
  }
  function picHTML(st) {
    var col = leadColor(st);
    if (!col) return '';
    if (col[3]) {
      var src = /^https?:\/\//.test(String(col[3])) ? String(col[3]) : SSCDN + 'Color/' + col[3] + '_f_fm.jpg';
      return '<img src="' + src + '" alt="" loading="lazy" decoding="async" data-t="' + esc(st.t) +
        '" data-hex="' + esc(col[1]) + '" onerror="' + (typeof window.rvaPhotoFail === 'function' ? 'rvaPhotoFail(this)' : 'this.style.display=&quot;none&quot;') + '">';
    }
    if (typeof window.garment === 'function') { try { return window.garment(st.t, col[1]); } catch (e) {} }
    return '<i style="background:' + esc(col[1]) + '"></i>';
  }
  function priceHTML(st) {
    if (typeof window.piecePrice !== 'function' || !window.S || typeof window.money !== 'function') return '';
    try {
      var col = leadColor(st);
      var p = window.piecePrice(st, col, window.S.qty, window.S.front, window.S.back);
      return '<span class="rvaSug__pr"><b>' + window.money(p) + '</b><small>each, printed</small></span>';
    } catch (e) { return ''; }
  }
  function mark(text, terms) {
    var t = String(text), low = t.toLowerCase(), hit = [];
    terms.forEach(function (term) {
      if (!term) return;
      var i = low.indexOf(term);
      while (i >= 0) { for (var k = i; k < i + term.length; k++) hit[k] = true; i = low.indexOf(term, i + term.length); }
    });
    var out = '', open = false;
    for (var c = 0; c < t.length; c++) {
      if (hit[c] && !open) { out += '<mark>'; open = true; }
      if (!hit[c] && open) { out += '</mark>'; open = false; }
      out += esc(t.charAt(c));
    }
    if (open) out += '</mark>';
    return out;
  }

  function matches(raw) {
    var p = rvaSearch.parse(raw), q = p.q;
    if (!q) return { q: q, terms: [], list: [] };
    var num = [], other = [];
    window.STYLES.forEach(function (st) {
      var s = rvaSearch.norm(st.s);
      if (s && s.indexOf(q) === 0) { num.push(st); return; }
      if (!rvaSearch.test(st, p)) return;
      (p.words.some(function (t) { return s.indexOf(t) === 0; }) ? num : other).push(st);
    });
    var rank = function (st) {
      var r = window.POP_RANK ? window.POP_RANK[st.b + '|' + st.s] : null;
      return r == null ? 9999 : r;
    };
    num.sort(function (a, b) { return String(a.s).length - String(b.s).length || rank(a) - rank(b) || String(a.s).localeCompare(String(b.s)); });
    other.sort(function (a, b) { return rank(a) - rank(b); });
    return { q: q, terms: rvaSearch.marks(p), list: num.concat(other).slice(0, MAX) };
  }

  function attach(input, opts) {
    if (!input || input.dataset.rvaSug) return;
    input.dataset.rvaSug = '1';
    var host = input.parentNode;
    if (host && getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var panel = document.createElement('div');
    panel.className = 'rvaSug';
    panel.id = 'rvaSug' + (++seq);
    panel.hidden = true;
    panel.setAttribute('role', 'listbox');
    host.appendChild(panel);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-expanded', 'false');

    var items = [], sel = -1, timer = null, lastQ = '';

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      sel = -1;
    }
    function highlight(i) {
      var opts2 = panel.querySelectorAll('.rvaSug__it');
      sel = i;
      Array.prototype.forEach.call(opts2, function (el, k) {
        el.setAttribute('aria-selected', String(k === i));
      });
      if (i >= 0 && opts2[i]) input.setAttribute('aria-activedescendant', opts2[i].id);
      else input.removeAttribute('aria-activedescendant');
    }
    function fit() {
      var vw = window.innerWidth, hr = host.getBoundingClientRect();
      var w = Math.min(Math.max(hr.width, 400), vw - 16);
      var left = Math.max(8, Math.min(hr.left, vw - 8 - w));
      panel.style.width = w + 'px';
      panel.style.left = (left - hr.left) + 'px';
    }
    function render() {
      var q = input.value;
      if (!q.trim()) { close(); return; }
      if (!haveStyles()) { ensureData(render); return; }
      var m = matches(q);
      items = m.list;
      lastQ = m.q;
      var html = '';
      if (items.length) {
        html = '<ul>' + items.map(function (st, i) {
          return '<li><a class="rvaSug__it" role="option" id="' + panel.id + '-' + i + '" href="' + styleHref(st) + '" aria-selected="false">' +
            '<span class="rvaSug__pic">' + picHTML(st) + '</span>' +
            '<span class="rvaSug__txt"><b>' + mark(st.b + ' ' + st.s, m.terms) + '</b><em>' + mark(st.n, m.terms) + '</em></span>' +
            priceHTML(st) + '</a></li>';
        }).join('') + '</ul>';
      } else {
        html = '<div class="rvaSug__none">No style matches &ldquo;' + esc(q.trim()) + '&rdquo;</div>';
      }
      if (opts.all && items.length) {
        html += '<button type="button" class="rvaSug__all">See all matches for &ldquo;' + esc(q.trim()) + '&rdquo; &rarr;</button>';
      }
      panel.innerHTML = html;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      sel = -1;
      fit();
    }
    function go(i) {
      var st = items[i];
      if (!st) return;
      close();
      location.href = styleHref(st);
    }
    function submitAll() {
      close();
      var form = input.form;
      if (form) {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(render, 70);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim() && (panel.hidden || lastQ !== input.value.trim().toLowerCase())) render();
    });
    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      var n = items.length;
      if (e.key === 'ArrowDown' && n) { e.preventDefault(); highlight((sel + 1) % n); }
      else if (e.key === 'ArrowUp' && n) { e.preventDefault(); highlight((sel - 1 + n) % n); }
      else if (e.key === 'Enter') {
        if (sel >= 0) { e.preventDefault(); e.stopImmediatePropagation(); go(sel); }
        else close();
      }
      else if (e.key === 'Escape') { e.preventDefault(); close(); }
    }, true);
    input.addEventListener('blur', function () { setTimeout(close, 160); });
    panel.addEventListener('mousedown', function (e) { e.preventDefault(); });
    panel.addEventListener('click', function (e) {
      var a = e.target.closest('.rvaSug__it');
      if (a) { e.preventDefault(); go(Array.prototype.indexOf.call(panel.querySelectorAll('.rvaSug__it'), a)); return; }
      if (e.target.closest('.rvaSug__all')) submitAll();
    });
    window.addEventListener('resize', function () { if (!panel.hidden) fit(); });
  }

  function start() {
    injectCSS();
    attach(document.getElementById('rvaHeaderSearch'), { all: true });
    attach(document.getElementById('q'), { all: false });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();